module.exports = __webpack_public_path__ + "img/share.893178e6.jpg";